import { render, staticRenderFns } from "./outside-page.vue?vue&type=template&id=62743c05&scoped=true&"
import script from "./outside-page.vue?vue&type=script&lang=js&"
export * from "./outside-page.vue?vue&type=script&lang=js&"
import style0 from "./outside-page.vue?vue&type=style&index=0&id=62743c05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62743c05",
  null
  
)

export default component.exports